// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  ICertificationWebpagePersonalDataApi,
  ICertificationWebpagePersonalDataApiRequest,
  ICertificationWebpagePersonalDataApiResponse,
  ICertificationWebpagePersonalDataApiGetDetailAttrs,
  ICertificationWebpagePersonalDataApiUpdateAttrs,
} from 'interfaces/webpage/certification/registration/personal-data/personal-data-api.interface'

// Constant
import { ApiConstantHc, ApiConstantHcBase } from 'constant'

// Utils
import { axios_renderHcUrl } from 'utils'

export class CertificationWebpagePersonalDataApi
  extends BaseApi<ICertificationWebpagePersonalDataApi>
  implements ICertificationWebpagePersonalDataApiRequest
{
  readonly url = ApiConstantHc.CERTIFICATION_REGISTRATION_PERSONAL_DATA_URL
  private certificateRegistrationPersonalDataUrl = axios_renderHcUrl(this.url, ApiConstantHcBase.ASSESSMENT)

  /**
   * @description Get personal data detail
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationWebpagePersonalDataApiGetDetailAttrs} payload
   *
   * @return {Promise<ICertificationWebpagePersonalDataApiResponse>} Promise<ICertificationWebpagePersonalDataApiResponse>
   */
  async certificationWebpagePersonalData_getDetail(
    payload: ICertificationWebpagePersonalDataApiGetDetailAttrs,
  ): Promise<ICertificationWebpagePersonalDataApiResponse> {
    return this.POST(
      `${this.certificateRegistrationPersonalDataUrl}/${payload.params.assessmentId}`,
      {},
      { ...payload.requestConfig },
    )
  }

  /**
   * @description Update personal data
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationWebpagePersonalDataApiUpdateAttrs} payload
   *
   * @return {Promise<ICertificationWebpagePersonalDataApiResponse>} Promise<ICertificationWebpagePersonalDataApiResponse>
   */
  async certificationWebpagePersonalData_update(
    payload: ICertificationWebpagePersonalDataApiUpdateAttrs,
  ): Promise<ICertificationWebpagePersonalDataApiResponse> {
    return this.POST(`${this.certificateRegistrationPersonalDataUrl}/update/${payload.params.assessmentId}`, payload.body, {
      ...payload.requestConfig,
    })
  }
}
